'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ClientPlacedAd = require('./ClientPlacedAd');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ClientPlacedAd).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-components/lib/ClientPlacedAd/index.js
 ** module id = 459
 ** module chunks = 1
 **/